export function determineLanguageAlignment(rtl) {
  return rtl ? "right" : "left";
}
